module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var columns = widget.gridColumns() 
    ; __append("\n")
    ;  var actions = widget.gridActions() 
    ; __append("\n")
    ;  if (widget.showHeader) { 
    ; __append("\n	<table class=\"gridview__table\">\n		<colgroup>\n			")
    ;  Util.each(columns, function (column) { 
    ; __append("\n			<col width=\"")
    ; __append(escapeFn( column.width ? column.width : "*" ))
    ; __append("\">\n			")
    ;  }) 
    ; __append("\n\n			")
    ;  Util.each(actions, function (action) { 
    ; __append("\n			<col width=\"")
    ; __append(escapeFn( action.width ? action.width : "*" ))
    ; __append("\">\n			")
    ;  }) 
    ; __append("\n		</colgroup>\n		<tbody>\n		<tr>\n			")
    ;  Util.each(columns, function (column) { 
    ; __append("\n			<td data-is-sorted=\"")
    ; __append(escapeFn( column.sorted ))
    ; __append("\">\n				")
    ; __append(escapeFn( column.title ))
    ; __append("\n			</td>\n			")
    ;  }) 
    ; __append("\n			")
    ;  Util.each(actions, function (action) {
			if (!Util.isDefined(action.enabled) || (Util.isDefined(action.enabled) && (Util.isFunction(action.enabled) || !!action.enabled))) { 
    ; __append("\n					<td></td>\n				")
    ;  }
			}) 
    ; __append("\n		</tr>\n		</tbody>\n	</table>\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}